import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import DropDown from './DropDown';
import { AvatarDisplay } from '../AvatarSelector';
import { DEFAULT_AVATAR } from '../../utils/avatars';
import { useAuth } from '../../context/AuthContext';
import AnimatedLogo from '../AnimatedLogo';

export default function Header({
  logoUrl,
  colorVariant,
  cart,
}) {
  const [isSticky, setIsSticky] = useState(false);
  const [mobileToggle, setMobileToggle] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const { user, logout: authLogout } = useAuth();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleLogout = async () => {
    await authLogout();
    window.location.href = '/';
  };
  return (
    <header
      className={`cs_site_header cs_style_1 cs_sticky_header ${
        colorVariant ? colorVariant : 'cs_primary_color'
      } ${isSticky ? 'cs_gescout_show' : ''}`}
    >
      <div className="cs_main_header">
        <div className="container">
          <div className="cs_main_header_in">
            <div className="cs_main_header_left">
              <AnimatedLogo logoUrl={logoUrl} animationType="glitch" />
            </div>
            <div className="cs_main_header_center">
              <div className="cs_nav cs_medium cs_primary_font">
                <ul
                  className={`${
                    mobileToggle ? 'cs_nav_list cs_active' : 'cs_nav_list'
                  }`}
                >
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li className="menu-item-has-children">
                    <Link to="/">About</Link>
                    <DropDown>
                      <ul>
                        <li><Link to='about'>About Us</Link></li>
                        <li><Link to='team'>Team</Link></li>
                      </ul>
                    </DropDown>
                  </li>
                  <li>
                    <Link to="service">Services</Link>
                  </li>
                  <li>
                    <Link to="blog">Blog</Link>
                  </li>
                  <li>
                    <Link to="contact">Contact</Link>
                  </li>
                  <li>
                    <Link to="portfolio">Portfolio</Link>
                  </li>
                </ul>
                <span
                  className={
                    mobileToggle
                      ? 'cs_menu_toggle cs_teggle_active'
                      : 'cs_menu_toggle'
                  }
                  onClick={() => setMobileToggle(!mobileToggle)}
                >
                  <span></span>
                </span>
              </div>
            </div>
            <div className="cs_main_header_right">
              {user ? (
                <div style={{ position: 'relative' }}>
                  <button
                    onClick={() => setShowUserMenu(!showUserMenu)}
                    className={`cs_btn cs_style_1 ${
                      colorVariant ? 'cs_btn_white' : ''
                    }`}
                    style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', padding: '0.5rem 1rem' }}
                  >
                    <AvatarDisplay avatarId={user.description || DEFAULT_AVATAR.id} size="tiny" />
                    <span>Hello, {user.first_name || 'User'}</span>
                    <span style={{ fontSize: '12px' }}>▼</span>
                  </button>
                  {showUserMenu && (
                    <div
                      style={{
                        position: 'absolute',
                        top: '100%',
                        right: 0,
                        marginTop: '0.5rem',
                        backgroundColor: 'white',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        minWidth: '220px',
                        zIndex: 1000,
                      }}
                    >
                      <Link
                        to="/dashboard"
                        style={{
                          display: 'block',
                          padding: '1rem',
                          color: '#1a1a1a',
                          textDecoration: 'none',
                          borderBottom: '1px solid #eee',
                        }}
                        onClick={() => setShowUserMenu(false)}
                      >
                        Dashboard
                      </Link>
                      <Link
                        to="/settings"
                        style={{
                          display: 'block',
                          padding: '1rem',
                          color: '#1a1a1a',
                          textDecoration: 'none',
                          borderBottom: '1px solid #eee',
                        }}
                        onClick={() => setShowUserMenu(false)}
                      >
                        Settings
                      </Link>
                      <button
                        onClick={handleLogout}
                        style={{
                          display: 'block',
                          width: '100%',
                          padding: '1rem',
                          textAlign: 'left',
                          border: 'none',
                          background: 'none',
                          color: '#dc3545',
                          cursor: 'pointer',
                          fontFamily: 'inherit',
                          fontSize: 'inherit',
                        }}
                      >
                        Logout
                      </button>
                    </div>
                  )}
                </div>
              ) : (
                <Link
                  to="/login"
                  className={`cs_btn cs_style_1  ${
                    colorVariant ? 'cs_btn_white' : ''
                  }`}
                >
                  Login | Register
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
